import React from "react";
import { motion, useReducedMotion } from "framer-motion";

// Scroll-triggered fade-up reveal.
export function Reveal({ children, delay = 0, y = 28, className = "", as = "div" }) {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={reduce ? { opacity: 1 } : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.75, delay, ease: [0.19, 1, 0.22, 1] }}
    >
      {children}
    </MotionTag>
  );
}

// Line-by-line masked reveal for headings. `lines` is array of strings/nodes.
export function MaskedLines({ lines, className = "", lineClass = "", delay = 0 }) {
  const reduce = useReducedMotion();
  return (
    <span className={className} aria-label={typeof lines[0] === "string" ? lines.join(" ") : undefined}>
      {lines.map((ln, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={`block ${lineClass}`}
            initial={reduce ? { opacity: 0 } : { y: "110%" }}
            animate={reduce ? { opacity: 1 } : { y: "0%" }}
            transition={{ duration: 0.9, delay: delay + i * 0.12, ease: [0.19, 1, 0.22, 1] }}
          >
            {ln}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
